var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncidents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3790_54061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM11.9854 16.8848C11.0863 16.8849 10.3574 17.48 10.3574 18.2139C10.3574 18.9478 11.0862 19.5428 11.9854 19.543C12.8847 19.543 13.6143 18.9479 13.6143 18.2139C13.6142 17.4799 12.8846 16.8848 11.9854 16.8848ZM11.9863 4C11.7027 4 11.4219 4.04894 11.1631 4.14355C10.9044 4.23811 10.6732 4.37627 10.4844 4.54883C10.2956 4.72148 10.1533 4.92496 10.0674 5.14551C9.98151 5.36609 9.95329 5.59914 9.98535 5.8291L11.3838 15.6426C11.401 15.763 11.472 15.8745 11.583 15.9551C11.694 16.0357 11.8378 16.0801 11.9863 16.0801C12.1347 16.08 12.2778 16.0355 12.3887 15.9551C12.4996 15.8745 12.5707 15.763 12.5879 15.6426L13.9863 5.8291C14.0184 5.59912 13.9902 5.3661 13.9043 5.14551C13.8184 4.92502 13.677 4.72144 13.4883 4.54883C13.2994 4.37613 13.0674 4.23816 12.8086 4.14355C12.5499 4.04903 12.2697 4.00004 11.9863 4Z",
    fill: "#003771"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3790_54061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidents);
export default __webpack_public_path__ + "static/media/Incidents.ab57be91e77ba9ab6e5249c6210d5467.svg";
export { ForwardRef as ReactComponent };